import { Typography } from '@mui/material';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { VrsCallCommentsAbuseFormControl } from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Textarea } from 'features/ui/elements';

export const VrsCallCommentsAbuseTextareaControl: FC<
  VrsCallCommentsAbuseFormControl
> = ({ control }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText',
  });
  const maxLength = 1500;

  return (
    <>
      <Typography
        title='abuse-additional-text'
        variant='subtitle2'
        color={theme.palette.grey[300]}
        mt={12}
      >
        {t('additionalText')}
      </Typography>
      <Controller
        control={control}
        name='commentText'
        rules={{ maxLength }}
        render={({ field: { ref, ...args } }) => (
          <Description
            title='abuse-comment-text'
            {...args}
            slotProps={{ htmlInput: { maxLength } }}
          />
        )}
      />
    </>
  );
};

const Description = styled(Textarea)`
  margin-top: ${theme.spacing(8)};
`;
